import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import * as queryString from 'query-string'

import { BillItem } from '../../components/bag'
import { Button } from '../../components/common/button'
import { getInitialPrice, getUpsellPrice } from '../../redux/slices/configSlice'
import {
	getCardToken,
	getEmail,
	getFbc,
	getFbp,
	getFirstUpsell,
	getFourthUpsell,
	getIsLegalFlow,
	getPayPalToken,
	getSecondUpsell,
	getThirdUpsell,
	getUserId,
	setFirstUpsell,
	setFourthUpsell,
	setSecondUpsell,
	setThirdUpsell,
} from '../../redux/slices/userSlice'

import { ampEvent, ampEventWithEventProperty } from '../../utils/amplitude'
import { paramsToQuery } from '../../utils/historyDecorators'
import { upsellsTypes } from '../upsell/upsellsTypes'
import {
	payPalRecurentRequest,
	cardRecurentRequest,
} from './requestHandler/requestsHandler'
import { bagList } from './bagList'

import './styles.scss'
import { purchasePropertyFetch } from '../../utils/analyticsRequest'

const BagScreen = () => {
	const location = useLocation()
	const history = useHistory()
	const dispatch = useDispatch()
	const params = queryString.parse(location.search)

	const email = useSelector(getEmail)
	const payPalToken = useSelector(getPayPalToken)
	const cardToken = useSelector(getCardToken)
	const firstUpsell = useSelector(getFirstUpsell)
	const secondUpsell = useSelector(getSecondUpsell)
	const thirdUpsell = useSelector(getThirdUpsell)
	const fourthUpsell = useSelector(getFourthUpsell)
	const fbc = useSelector(getFbc)
	const fbp = useSelector(getFbp)
	const upsellPrice = useSelector(getUpsellPrice)
	const isLegalFlow = useSelector(getIsLegalFlow)

	const [bagOffers, setBagOffers] = useState(bagList)
	const [btnDisabled, setBtnDisabled] = useState(false)
	const [isActive, setIsActive] = useState(false)
	const [price, setPrice] = useState(0)

	const user_id = useSelector(getUserId)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	const bagDetails = location?.state?.bag

	const updateBagOffersStatus = idx => {
		setBagOffers(
			bagOffers.map((offer, index) => {
				if (idx === index) {
					offer.isSelected = !offer.isSelected
				}
				return offer
			}),
		)
	}

	const onPayment = (isUpsell, upsellNumber, body) => {
		if (payPalToken && !isUpsell) {
			payPalRecurentRequest({ ...body, token: payPalToken })
				.then(res => {
					ampEventWithEventProperty(`purchase_upsell${upsellNumber}`, {
						value: upsellPrice / 100,
					})

					purchasePropertyFetch(
						{
							amount: upsellPrice,
							type: 'upsell',
						},
						user_id,
					)

					if (upsellNumber === 1) {
						dispatch(setFirstUpsell())
					} else if (upsellNumber === 2) {
						dispatch(setSecondUpsell())
					} else if (upsellNumber === 3) {
						dispatch(setThirdUpsell())
					} else if (upsellNumber === 4) {
						dispatch(setFourthUpsell())
					}
				})
				.catch(e => console.error(e))
		} else if (cardToken && !isUpsell) {
			cardRecurentRequest({ ...body, token: cardToken })
				.then(res => {
					ampEventWithEventProperty(`purchase_upsell${upsellNumber}`, {
						value: upsellPrice / 100,
					})

					purchasePropertyFetch(
						{
							amount: upsellPrice,
							type: 'upsell',
						},
						user_id,
					)

					if (upsellNumber === 1) {
						dispatch(setFirstUpsell())
					} else if (upsellNumber === 2) {
						dispatch(setSecondUpsell())
					} else if (upsellNumber === 3) {
						dispatch(setThirdUpsell())
					} else if (upsellNumber === 4) {
						dispatch(setFourthUpsell())
					}
				})
				.catch(e => console.error(e))
		}
	}

	const onUpgradeButtonCLicked = body => {
		setBtnDisabled(true)

		bagOffers.forEach(offer => {
			switch (offer.upsell) {
				case upsellsTypes.UPSELL1: {
					if (offer.isSelected) {
						onPayment(firstUpsell, 1, body)
					}
					break
				}
				case upsellsTypes.UPSELL2: {
					if (offer.isSelected) {
						onPayment(secondUpsell, 2, body)
					}
					break
				}
				case upsellsTypes.UPSELL3: {
					if (offer.isSelected) {
						onPayment(thirdUpsell, 3, body)
					}
					break
				}
				case upsellsTypes.UPSELL4: {
					if (offer.isSelected) {
						onPayment(fourthUpsell, 4, body)
					}
					break
				}
				default: {
					console.log(`Upsell (${offer.upsell}) not found.`)
				}
			}
		})

		history.push({
			pathname: '/success',
			search: isLegalFlow
				? paramsToQuery({ user_id, external_id: user_id })
				: paramsToQuery({
						user_id,
						external_id: user_id,
						upsell_test,
						initial_price,
				  }),
		})
	}

	const onSkipBtnClicked = () => {
		history.push({
			pathname: '/success',
			search: isLegalFlow
				? paramsToQuery({ user_id, external_id: user_id })
				: paramsToQuery({
						user_id,
						external_id: user_id,
						upsell_test,
						initial_price,
				  }),
		})
	}

	useEffect(() => {
		let total = 0

		bagOffers.forEach(offer => {
			if (offer.isSelected) {
				if (parseInt(upsell_test) === 999) {
					total += 10
				} else {
					total += 5
				}
			}
		})

		setPrice(total)
	}, [bagOffers])

	useEffect(() => {
		let total = 0

		if (bagDetails) {
			bagOffers.map((offer, index) => {
				offer.isSelected = bagDetails[index].isSelected
				if (offer.isSelected) {
					if (parseInt(upsell_test) === 999) {
						total += 10
					} else {
						total += 5
					}
				}

				return offer
			})
			setPrice(total)
		}

		setTimeout(() => {
			ampEvent('bag_shown')
		}, 0)

		setTimeout(() => {
			setIsActive(true)
		}, 350)
	}, [])

	return (
		<div className={`bag ${isActive ? 'bag--active' : ''}`}>
			<img
				src="/images/bag/shopping-bags.png"
				alt="Shopping bags."
				className="bag__image"
			/>
			<h2 className="bag__title">Shopping Bag</h2>
			<div className="bag__offers-wrapper">
				{bagOffers.map((offer, index) => (
					<div key={index}>
						<BillItem
							{...offer}
							prevPrice={upsellPrice === 999 ? '20' : '10'}
							currPrice={upsellPrice / 100}
							onItemClick={() => updateBagOffersStatus(index)}
						/>
						{index < bagOffers.length - 1 && (
							<div className="bag__offers-wrapper__border"></div>
						)}
					</div>
				))}
			</div>
			<div className="bag__price">
				<div className="bag__price__border"></div>
				<p className="bag__price__total">Total: USD {price}</p>
				<Button
					buttonText="Get My Program"
					onClick={() =>
						onUpgradeButtonCLicked({
							email,
							amount: upsellPrice,
							product_id: process.env.REACT_APP_PRODUCT_ID,
							pixel_id: process.env.REACT_APP_PIXEL_ID,
							external_id: window.id,
							userAgent: navigator.userAgent,
							user_source: window.location.origin,
							user_id: user_id,
							fbp: fbp,
							fbc: fbc,
						})
					}
					disabled={price ? btnDisabled : !price}
				/>
				<button
					className="bag__price__skip-button"
					onClick={onSkipBtnClicked}
					disabled={btnDisabled}
				>
					Just a photo, please
				</button>
			</div>
		</div>
	)
}

export { BagScreen }
